import { useT } from "@transifex/react";
import { ButtonColorVariant, IconPosition } from "../../complex/teacherArea/AreaButton";
import { FormattedText } from "../../complex/teacherArea/FormattedText";
import BasePopupWrapper, { TitleColorVariants } from "./BasePopupWrapper";

interface DeleteConfirmationPopupProps {
    isOpen: boolean;
    title: string;
    description: string;
    onClose: () => void;
    onConfirm: () => void;
    primaryButtonColor?: ButtonColorVariant;
}

const DeleteConfirmationPopup = (props: DeleteConfirmationPopupProps) => {
    const t = useT();

    const t_delete = t("Delete", { _tags: "ClassActivity, ClassActivityPopup" });
    const t_cancel = t("Cancel", { _tags: "ClassActivity, ClassActivityPopup" });

    return (
        <BasePopupWrapper
            isOpen={props.isOpen}
            onClose={props.onClose}
            title={props.title}
            titleColor={TitleColorVariants.DANGER}
            titleIcon="alert"
            primaryButton={{
                text: t_delete,
                icon: "trash",
                iconPosition: IconPosition.RIGHT,
                onClick: props.onConfirm,
                colorVariant: ButtonColorVariant.DANGER,
                className: "min-w-[180px]",
            }}
            secondaryButton={{
                text: t_cancel,
                onClick: props.onClose,
                colorVariant: props.primaryButtonColor ?? ButtonColorVariant.DEFAULT,
                className: "min-w-[180px]",
            }}
        >
            <FormattedText
                rawText={props.description}
                textColor="text-l text-p6-grey-dark py-xxs [&>b]:font-semibold"
            />
        </BasePopupWrapper>
    );
};

export default DeleteConfirmationPopup;
